import { CART_UUID } from 'utility/constants/baskets';
import { setCookie } from 'utility/tools/cookies';

function storeUuid({ uuid }) {
	setCookie({ name: CART_UUID, value: uuid });
}

export default storeUuid;
